import { useCallback } from 'react';
import TelegramWebApp from '../telegram-init';

type HapticImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type HapticNotificationType = 'error' | 'success' | 'warning';

/**
 * Hook for centralized haptic feedback management
 * Safely handles haptic feedback with error handling
 */
export const useHapticFeedback = () => {
  const impactOccurred = useCallback((style: HapticImpactStyle = 'medium') => {
    try {
      TelegramWebApp.HapticFeedback.impactOccurred(style);
    } catch (error) {
      // Silently fail if haptic feedback is not available
    }
  }, []);

  const notificationOccurred = useCallback((type: HapticNotificationType) => {
    try {
      TelegramWebApp.HapticFeedback.notificationOccurred(type);
    } catch (error) {
      // Silently fail if haptic feedback is not available
    }
  }, []);

  const selectionChanged = useCallback(() => {
    try {
      TelegramWebApp.HapticFeedback.selectionChanged();
    } catch (error) {
      // Silently fail if haptic feedback is not available
    }
  }, []);

  return {
    impactOccurred,
    notificationOccurred,
    selectionChanged
  };
};

